module.exports = __webpack_public_path__ + "img/logo_footer.8c6c813e.png";